module.exports = __webpack_public_path__ + "img/beranda.6c6a5609.svg";